var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({maxWidth: '600px'})},[_c('h3',{staticClass:"pb-3"},[_vm._v("The page you requested could not be found")]),_c('h1',{style:({color: _vm.mainTextColor})},[_vm._v("404")])])}
var staticRenderFns = []

export { render, staticRenderFns }